import {useCurrentUser} from "../../../../../../contexts/UserContext";
import React from "react";
import {Flex} from "antd";
import {MdOutlineEngineering} from "react-icons/md";
import EngineeringLetterButton from "./EngineeringLetter/EngineeringLetterButton";
import EngineeringAffidavitButton from "./Engineering-Affidavit/EngineeringAffidavitButton";
import EngineeringDocsButton from "./Engineering-Documents/EngineeringDocsButton";

const EngineeringSection : React.FC = () => {

    const {hasCapability} = useCurrentUser();

    return(
        <>
        {
            hasCapability('Download_Engineering') &&

            <>
                <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}><MdOutlineEngineering size={32}/>Engineering</Flex>

                <EngineeringLetterButton/>

                <EngineeringAffidavitButton/>

                <EngineeringDocsButton/>
            </>
        }
        </>
    )
}

export default EngineeringSection